import { motion } from "framer-motion";

export default function Why() {
  return (
    <div className="flex flex-col lg:flex-row justify-center items-center mt-20 px-4 gap-12 lg:gap-24">
      {/* Left Content */}
      <div className="w-full lg:w-[45%] max-w-xl">
        <h6 className="text-red-500 font-bold text-2xl text-center lg:text-left">
          WHY CHOOSE US
        </h6>
        <p className="mt-4 text-black text-3xl lg:text-4xl font-bold font-serif text-center lg:text-left">
          We Treat Your Home <br /> Like It's Our Own
        </p>
        <p className="mt-4 text-zinc-600 text-base text-center lg:text-left">
          We request you to kindly enlist our company in your regular vendor
          list and consider us for any future pest control or hygiene
          requirements.
        </p>

        {/* Box 1 */}
        <div className="flex gap-4 sm:gap-5 mt-6 bg-white border rounded-2xl p-4 sm:p-5 shadow-xl">
          <img
            src={require("./Pest-3.jpg")}
            className="h-[60px] sm:h-[70px] w-[60px] sm:w-[70px] border-2 rounded-full object-cover mt-1"
            alt="Top Rated"
          />
          <div>
            <h3 className="text-black text-lg sm:text-xl font-bold">
              Top Rated Services
            </h3>
            <p className="mt-1 sm:mt-2 text-zinc-600 text-sm sm:text-base">
              We assure you of our dedicated service, prompt response and
              professional approach at all times.
            </p>
          </div>
        </div>

        {/* Box 2 */}
        <div className="flex gap-4 sm:gap-5 mt-4 sm:mt-6 bg-white border rounded-2xl p-4 sm:p-5 shadow-xl">
          <img
            src={require("./Pest-1.jpg")}
            className="h-[60px] sm:h-[70px] w-[60px] sm:w-[70px] border-2 rounded-full object-cover mt-1"
            alt="Fully Equipped"
          />
          <div>
            <h3 className="text-black text-lg sm:text-xl font-bold">
              Fully Equipped
            </h3>
            <p className="mt-1 sm:mt-2 text-zinc-600 text-sm sm:text-base">
              With professional expertise and cost-effective solutions, we
              ensure a pest-free environment without compromising your safety.
            </p>
          </div>
        </div>
      </div>

      {/* Right Content - Image */}
      <div className="w-full lg:w-[45%] flex justify-center">
        <motion.img
          whileHover={{ scale: 1.08, boxShadow: "0 8px 32px rgba(0,0,0,0.25)" }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          src={require("./why-1.jpg")}
          alt="Main"
          className="w-full max-w-[400px] rounded-xl shadow-md cursor-pointer"
        />
      </div>
    </div>
  );
}
